import * as React from "react";
import { default as ReactSelect, Props } from "react-select";

export type SelectProps<T> = {
  value: T | null;
  searchable?: boolean;
  options: { label: string; value: T }[];
  className?: string;
  name?: string;
  disabled?: boolean;
  onChange: (val: { label: string; value: T } | null) => void;
};

export type MultiSelectProps<T> = SelectProps<T> & {
  value: T[];
  onChange: (val: readonly T[]) => void;
};

const Select: React.FC<Props> = React.forwardRef<any, Props>(
  (props, ref) => {
    return (
      <ReactSelect
        {...props}
        menuShouldScrollIntoView={false}
        classNames={{
          control: (state) =>
            "flex w-full rounded-md border border-input bg-background text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          ...props.classNames,
        }}
        ref={ref}
      />
    );
  },
);

Select.displayName = "Select";

export { Select };
